export const INCIDENT_OPERATION_TEXT = {
  incident: {
    title: 'OperationProgress_Incident_Title',
    description: 'OperationProgress_Incident_Description',
  },
  videoChat: {
    title: 'OperationProgress_Video_Title',
    description: 'OperationProgress_Video_Description',
  },
  locate: {
    title: 'OperationProgress_Location_Title',
    description: 'OperationProgress_Location_Description',
  },
  chat: {
    title: 'OperationProgress_Chat_Title',
    description: 'OperationProgress_Chat_Description',
  },
} as const;

export type IncidentOperation = keyof typeof INCIDENT_OPERATION_TEXT;
export type IncidentCommandAction = Exclude<IncidentOperation, 'incident'>;
